import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { LabelDescriptionOnTooltipProps as Props } from './types';

export const LabelDescriptionOnTooltip = memo(({ className, label }: Props) => {
  if (!label.description) return null;

  return (
    <Styled.Wrapper
      className={classnames('LabelDescriptionOnTooltip', className)}
      sx={SX.root}
    >
      <Typography variant="body4" fontWeight={600}>
        {label.name}
      </Typography>
      <Typography variant="body4" fontWeight={400}>
        {label.description}
      </Typography>
    </Styled.Wrapper>
  );
});

LabelDescriptionOnTooltip.displayName = 'LabelDescriptionOnTooltip';
